import { createFileRoute } from '@tanstack/react-router';
import Error404 from '../components/Errors/Error404';

/**
 * Catch-all 404 Route
 *
 * This route matches any path that hasn't been matched by other routes.
 * The $splat parameter in the filename makes this a catch-all route.
 */
export const Route = createFileRoute('/$splat')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: NotFoundRoute,
});

function NotFoundRoute() {
  return <Error404 />;
}
